import {
    USER_WORKSPACE_ROLE_ACTIONS,
    UserWorkspaceRole,
    WorkspaceAction,
} from "@common/userWorkspaceRoles";

export function canRoleEditCoa(role: UserWorkspaceRole): boolean {
    return USER_WORKSPACE_ROLE_ACTIONS[role].includes(WorkspaceAction.COA_EDIT);
}
